import React, { useState } from 'react';
import styles from './Footer.module.css';
import logo from '../assets/logo.png'; // Ensure the logo path is correct

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle newsletter subscription logic
    console.log('Subscribe email:', email);
    setEmail('');
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerContent}>
          {/* Column 1: Logo Section */}
          <div className={styles.logoSection}>
            <div className={styles.footerLogo}>
              <div className={styles.logo}>
                <div className={styles.logoIcon}>
                  <img 
                    src={logo}
                    alt="Virtual IP Logo" 
                    className={styles.logoImage}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Column 2: Contact Details */}
          <div className={styles.contactSection}>
            <h3 className={styles.sectionTitle}>Contact Detail</h3>
            <div className={styles.contactItem}>
              <div className={styles.contactIcon}>📍</div>
              <span>7801 Alma Dr Suite 105 Plano, TX 75025</span>
            </div>
            <div className={styles.contactItem}>
              <div className={styles.contactIcon}>✉️</div>
              <span>info@virtualplus.com</span>
            </div>
            <div className={styles.contactItem}>
              <div className={styles.contactIcon}>📞</div>
              <span>+1 (972) 476 5199</span>
            </div>
          </div>

          {/* Column 3: Follow Us */}
          <div className={styles.socialSection}>
  <h3 className={styles.sectionTitle}>Follow Us</h3>
  <div className={styles.socialIcons}>

    {/* Facebook */}
    <a 
      href="https://www.facebook.com/share/1TEoWupbq5/?mibextid=wwXIfr" 
      className={styles.socialIcon} 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 
        12c0 5.991 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.469h3.047v-2.641c0-3.019 
        1.792-4.688 4.533-4.688 1.312 0 2.686.235 2.686.235v2.953h-1.512c-1.491 
        0-1.953.925-1.953 1.874v2.267h3.328l-.531 3.469h-2.797v8.385c5.737-.9 
        10.125-5.863 10.125-11.854z"/>
      </svg>
    </a>

    {/* LinkedIn */}
    <a 
      href="https://www.linkedin.com/company/virtualip/" 
      className={styles.socialIcon} 
      target="_blank" 
      rel="noopener noreferrer"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452H16.89v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 
        0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 
        1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 
        4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 
        0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 
        2.064 2.063 0 1.139-.925 2.065-2.064 
        2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 
        0H1.771C.792 0 0 .774 0 1.729v20.542C0 
        23.227.792 24 1.771 24h20.451C23.2 24 
        24 23.227 24 22.271V1.729C24 .774 23.2 
        0 22.222 0h.003z"/>
      </svg>
    </a>

    {/* Instagram */}
   {/* Instagram */}
<a
  href="https://www.instagram.com/virtual.ip?igsh=MTNsbG00MHgzM3I3Mg=="
  className={styles.socialIcon}
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Virtual IP on Instagram"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    width="28"
    height="28"
    role="img"
    aria-hidden="false"
    focusable="false"
    fill="currentColor"
    style={{ display: 'block' }} // prevents inline whitespace issues
  >
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.35 3.608 1.325.975.975 1.262 2.242 1.324 3.608.058 1.266.069 1.646.069 4.85s-.012 3.584-.069 4.85c-.062 1.366-.35 2.633-1.324 3.608-.975.975-2.242 1.262-3.608 1.324-1.266.058-1.646.069-4.85.069s-3.584-.012-4.85-.069c-1.366-.062-2.633-.35-3.608-1.324-.975-.975-1.262-2.242-1.324-3.608C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.069-4.85c.062-1.366.35-2.633 1.324-3.608C4.531 2.583 5.798 2.296 7.164 2.234 8.43 2.176 8.81 2.163 12 2.163zM12 0C8.741 0 8.332.013 7.052.072 5.775.131 4.638.425 3.678 1.385c-.96.96-1.254 2.097-1.313 3.374C2.013 5.741 2 6.15 2 9.999s.013 4.259.072 5.539c.059 1.277.353 2.414 1.313 3.374.96.96 2.097 1.254 3.374 1.313 1.28.059 1.689.072 4.539.072s3.259-.013 4.539-.072c1.277-.059 2.414-.353 3.374-1.313.96-.96 1.254-2.097 1.313-3.374.059-1.28.072-1.689.072-4.539s-.013-3.259-.072-4.539c-.059-1.277-.353-2.414-1.313-3.374-.96-.96-2.097-1.254-3.374-1.313C15.668.013 15.259 0 12 0zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a3.999 3.999 0 110-7.998 3.999 3.999 0 010 7.998zm7.2-11.845a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z"/>
  </svg>
</a>


  </div>
</div>


          {/* Column 4: Newsletter */}
          <div className={styles.newsletterSection}>
            <h3 className={styles.sectionTitle}>Newsletter</h3>
            <form onSubmit={handleSubscribe} className={styles.newsletterForm}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="sample@email.com"
                className={styles.newsletterInput}
                required
              />
              <button type="submit" className={styles.subscribeButton}>
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className={styles.footerBottom}>
          <p className={styles.copyright}>
            Copyright © Virtual IP 2025
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;